import React from 'react';
import Confetti from 'react-confetti';

const OnboardingDone = () => {
  return (
    <div className="overflow-hidden">
      <Confetti numberOfPieces={200} recycle={false} tweenDuration={3000} />
      <label
        htmlFor="language"
        className="text-white font-hanken text-4xl font-extrabold"
      >
        <span className="text-purple3">That’s it! </span>
        Let me get your notebook setup ...
      </label>
    </div>
  );
};

export default OnboardingDone;
